module.exports = __webpack_public_path__ + "static/media/speaker-fan.c501b433.jpg";